import { bikeEnumToNumStatuses } from "../../../../data/bike-numeric-statuses";

export const labelItems = [
  {
    label: "Hidden",
    value: bikeEnumToNumStatuses.HIDDEN,
    color: "#808080",
  },
  {
    label: "Service",
    value: bikeEnumToNumStatuses.GARAGE,
    color: "#84ff00",
  },
  {
    label: "Stolen",
    value: bikeEnumToNumStatuses.POLICE,
    color: "#ff0000",
  },
  {
    label: "Police",
    value: bikeEnumToNumStatuses.LOST,
    color: "#00c6ff",
  },
  {
    label: "Free",
    value: bikeEnumToNumStatuses.FREE,
    color: "#fff"
  },
  {
    label: "Booked",
    value: bikeEnumToNumStatuses.BOOKED,
    color: "#0000ff",
  },
  {
    label: "On ride",
    value: bikeEnumToNumStatuses.RIDING,
    color: "#008000",
  },
  {
    label: "Transfer",
    value: bikeEnumToNumStatuses.TRANSFER,
    color: "#ffd900",
  },
];

export const pausedColor = "#ffb57b";



// WEBPACK FOOTER //
// ./src/views/pages/bikes/constants/map-filter-items.js